import { useCallback, useEffect, useRef, useState } from "react";
import { AutoComplete, Input, Spin } from "antd";
import Parser from "html-react-parser";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import type { SelectProps } from "antd/es/select";
import { debounce } from "lodash-es";
import api from "@/api";
import { DocumentType, CardType, LinkType, DocsMessageAction } from "./type";
import dataJson from "@/../public/data.json";
import { publicPath } from "@/utils/base";

import "./index.less";
import store from "@/stores";

const protocol = document.location.protocol;
const domain = window.location.host;
export const docsPrefix = "document";
const connectKey='1';
const allow=window.location.origin;
let key='';

const changeDocumentPathName=(str:string)=>{
    return str.replace('/'+docsPrefix,'')
}

function Document() {
  const iframeRef = useRef<any>(null);

  const navigate=useNavigate();
  const location=useLocation();
  const [iframeHeight, setIframeHeight] = useState(0);
  const [iframeSrc, setIframeSrc] = useState(changeDocumentPathName(window.location.pathname)+window.location.search+window.location.hash);
  const [loading, setLoading] = useState(true);
  const [iframeSuccess, setIframeSuccess] = useState(false);
  const srcRef=useRef(iframeSrc);
  console.log('iframeSrc:',iframeSrc);
  console.log('srcRef:',srcRef.current);
  useEffect(()=>{
    const messageHandler = (event: MessageEvent) => {
      const {data} = event;
      console.log('message from iframe:',data);
      if(data.action === DocsMessageAction.CONNECT){
        sendMessage(DocsMessageAction.CONNECT,'');
        key=connectKey+data.key;
        setIframeSuccess(true);
        //提交redux 保存iframe和发送消息方法
        store.dispatch({type:'setDocsIframe',payload:{
          iframe:iframeRef.current,
          sendMessage:sendMessage,
        }});
      }
      if(data.action ===DocsMessageAction.GET_SIZE){
        console.log('iframe size:',data.content);
        // setIframeHeight(data.content.height);
      }
      if(data.action==DocsMessageAction.HREF_CHANGE){
        const href=data.content;
        if(href && href!=srcRef.current){
          srcRef.current=href;
          navigate('/'+docsPrefix+href,{replace:true});
        }
      }

    }
    if(iframeRef.current){
      window.addEventListener('message',messageHandler);

    }
    
    return () => {
      window.removeEventListener('message',messageHandler);
      store.dispatch({type:'setDocsIframe',payload:null});
    }
  },[iframeRef.current])
  
  const sendMessage = useCallback(
    /**
     * 发送消息给iframe
     * @param {DocsMessageAction} action 
     * @param data 
     * @returns 
     */
    (action:DocsMessageAction,data: any) => {
    if(!iframeRef.current) return;
    if(action==DocsMessageAction.ROUTER_CHANGE && data==srcRef.current) return;//拦截 头部点击路由重复发送
    console.log('send message:',action,data);
    if(action==DocsMessageAction.ROUTER_CHANGE || action==DocsMessageAction.HREF_CHANGE){
      if(data.includes(docsPrefix)){
        data=changeDocumentPathName(data);
      }
    }
    iframeRef.current.contentWindow.postMessage({action:action,content:data,key:connectKey},allow);
  },[]);
  const onLoadHandler = (e:any) => {
    console.log('iframe load:',e);
    setLoading(false);
  }

  useEffect(()=>{
    console.log('location:',location,iframeSrc);
    const newUrl=changeDocumentPathName(location.pathname)+location.search+location.hash;
    if(newUrl == srcRef.current) return;
    srcRef.current=newUrl;
    console.log('location srcRef:',srcRef.current);
    sendMessage(DocsMessageAction.HREF_CHANGE,srcRef.current);
  },[location]);

  return (
    <Spin spinning={loading} size="large" tip={"文档加载中..."} wrapperClassName={`${docsPrefix}-spin`}>
      <div className={docsPrefix} >
          <iframe onLoad={onLoadHandler} 
          onError={(e)=>{
            console.log('iframe error',e);
          }}
          style={{display:iframeSuccess?'block':'none'}}  
          ref={iframeRef} src={allow+iframeSrc} ></iframe>
          <Outlet />
      </div>
    </Spin>
    
  );
}

export default Document;
